/* Daellia V3, product page: description "Read more" and the campaign strip arrows. No dependencies.
   Delegated listeners, so they keep working after Horizon re-renders the product section on variant change. */
(function () {
  'use strict';

  /* ---------- Description: Read more / Read less ---------- */
  function setClamp(btn, open) {
    var el = document.getElementById(btn.getAttribute('aria-controls'));
    if (!el) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    el.classList.toggle('is-open', open);
    btn.textContent = open ? (btn.getAttribute('data-label-less') || 'Read less') : (btn.getAttribute('data-label-more') || 'Read more');
  }

  function checkClamps(root) {
    (root || document).querySelectorAll('[data-dl-clamp-toggle]').forEach(function (btn) {
      var el = document.getElementById(btn.getAttribute('aria-controls'));
      if (!el || btn.getAttribute('aria-expanded') === 'true') return;
      if (!el.offsetParent) return; /* closed accordion: measure later */
      if (el.scrollHeight <= el.clientHeight + 4) {
        el.classList.remove('is-clamped');
        btn.hidden = true;
      }
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-dl-clamp-toggle]') : null;
    if (!btn) return;
    event.preventDefault();
    setClamp(btn, btn.getAttribute('aria-expanded') !== 'true');
  });

  /* ---------- Campaign strip arrows (desktop) ---------- */
  function stripStep(list) {
    var item = list.querySelector('.dl-camp__item');
    if (!item) return list.clientWidth * 0.8;
    var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
    var perView = Math.max(1, Math.floor(list.clientWidth / (item.offsetWidth + gap)) - 1);
    return (item.offsetWidth + gap) * perView;
  }

  function updateNav(section) {
    var list = section.querySelector('[data-dl-strip]');
    var nav = section.querySelector('[data-dl-strip-nav]');
    if (!list || !nav) return;
    var max = list.scrollWidth - list.clientWidth;
    nav.hidden = max <= 4;
    var prev = nav.querySelector('[data-dl-strip-prev]');
    var next = nav.querySelector('[data-dl-strip-next]');
    if (prev) prev.disabled = list.scrollLeft <= 4;
    if (next) next.disabled = list.scrollLeft >= max - 4;
  }

  function initStrips(root) {
    (root || document).querySelectorAll('.dl-camp--strip').forEach(function (section) {
      var list = section.querySelector('[data-dl-strip]');
      if (!list || list.dataset.dlStripBound) return;
      list.dataset.dlStripBound = '1';
      var raf = 0;
      list.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; updateNav(section); });
      }, { passive: true });
      updateNav(section);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-dl-strip-prev], [data-dl-strip-next]') : null;
    if (!btn) return;
    var section = btn.closest('.dl-camp--strip');
    var list = section && section.querySelector('[data-dl-strip]');
    if (!list) return;
    var dir = btn.hasAttribute('data-dl-strip-prev') ? -1 : 1;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    list.scrollBy({ left: dir * stripStep(list), behavior: reduce ? 'auto' : 'smooth' });
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.dl-camp--strip').forEach(updateNav);
  });

  document.addEventListener('toggle', function (event) {
    if (event.target && event.target.matches && event.target.matches('.dl-pdp-acc__desc[open]')) checkClamps(event.target);
  }, true);

  function init() {
    checkClamps();
    initStrips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    checkClamps();
    document.querySelectorAll('.dl-camp--strip').forEach(updateNav);
  });

  document.addEventListener('shopify:section:load', function (event) {
    checkClamps(event.target);
    initStrips(event.target);
  });
})();
